import { Link } from "react-router-dom";
import React from "react";
import "../styles/JavaFullStack.css";

const JavaFullStack = () => {
  return (
    <main className="java-page">

      <section className="java-hero">
        <div>
          <span>ENGINEERING SERVICE 04 · JAVA / SPRING / REACT</span>
          <h1>One strong stack, from interface to infrastructure</h1>
          <p>
            Build dependable digital products with Java at the core. We connect polished frontend experiences to resilient services, secure data and cloud-ready delivery.
          </p>
          <Link className="java-hero-link" to="/contact">Discuss your application <b aria-hidden="true">↗</b></Link>
        </div>
        <div className="java-blueprint" aria-label="Java full stack layers"><div className="java-blueprint-top"><span>APPLICATION MAP</span><b>BUILD 01</b></div><div className="java-layer"><i>01</i><strong>Experience</strong><span>React · Web UI</span></div><div className="java-layer java-layer-focus"><i>02</i><strong>Application</strong><span>Java · Spring Boot</span></div><div className="java-layer"><i>03</i><strong>Data & services</strong><span>SQL · REST · Cloud</span></div><div className="java-blueprint-foot"><span>BUILT FOR CHANGE</span><b>●●●</b></div></div>
      </section>

      <section className="java-stack">
        <div className="java-section-intro"><span>THE WHOLE PRODUCT, WORKING TOGETHER</span><h2>Full stack means fewer gaps between idea and impact</h2><p>We bring frontend, backend and delivery into one engineering plan, so the pieces fit together from the start.</p></div>

        <div className="java-grid">
          <article><strong>Frontend</strong><p>Responsive React interfaces with considered component structure and accessible interactions.</p></article>
          <article><strong>Backend</strong><p>Java and Spring Boot services designed around clear domain logic and reliable APIs.</p></article>
          <article><strong>Data layer</strong><p>Well-shaped relational data, practical persistence patterns and dependable integrations.</p></article>
          <article><strong>Cloud delivery</strong><p>Container-ready applications with deployment pipelines and operational visibility.</p></article>
        </div>
      </section>

      <section className="java-approach"><div><span>ENGINEERING APPROACH</span><h2>Ship with confidence, keep room to evolve</h2></div><ul><li><b>01</b><div><strong>Architecture with intent</strong><p>Choose a structure that supports today’s needs and sensible future change.</p></div></li><li><b>02</b><div><strong>Quality built into delivery</strong><p>Use code reviews, automated checks and observable services as part of the workflow.</p></div></li><li><b>03</b><div><strong>Security from the start</strong><p>Apply sound access, validation and data handling practices across the application.</p></div></li></ul></section>

      <section className="java-cta">
        <h2>Need a product built end to end?</h2>
        <p>Let’s map the stack, team and first release around your business priorities.</p>
        <Link to="/contact">Start a conversation ↗</Link>
      </section>

    </main>
  );
};

export default JavaFullStack;